import { render, staticRenderFns } from "./UserDashboardTabsPayments.vue?vue&type=template&id=f3ae5e76&scoped=true&"
import script from "./UserDashboardTabsPayments.vue?vue&type=script&lang=js&"
export * from "./UserDashboardTabsPayments.vue?vue&type=script&lang=js&"
import style0 from "./UserDashboardTabsPayments.vue?vue&type=style&index=0&id=f3ae5e76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3ae5e76",
  null
  
)

export default component.exports